import api from "../../api";

export const getRequests = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/admin/withdrawl?${query}`);
    return data
  } else {
    const { data } = await api.get('billing/admin/withdrawl');
    return data
  }
}

export const getOpenedRequests = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/admin/withdrawl?status=1&${query}`);
    return data
  } else {
    const { data } = await api.get('billing/admin/withdrawl?status=1');
    return data
  }
}

export const getFinishedRequests = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/admin/withdrawl?status=2&${query}`);
    return data
  } else {
    const { data } = await api.get('billing/admin/withdrawl?status=2');
    return data
  }
}

export const getRequest = async (id: any) => {
  const { data } = await api.get(`billing/admin/withdrawl/${id}`);
  return data
}

export const finishRequest = async (id: any, params: any) => {
  let formData = new FormData();
  formData.append("payment_voucher", params.file);
  formData.append("type", params.type);

  const { data } = await api.put(`billing/admin/withdrawl/${id}`, formData);
  return data
}